module.exports = __webpack_public_path__ + "static/media/test-photo.9891508c.jpeg";